module.exports = "/build/web/svg/social/small/facebook.e0c68439b21ed5ec5921704f0e175ba7.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/facebook.svg
// module id = 193
// module chunks = 24